import React from "react";
import styles from "./styles.module.scss";
import coachnow_logo from "app/images/Logo_dark.svg";
import analyze_badge from "app/images/Analyze_badge_dark.svg";
import orange_check from "app/images/orange_check.svg";
import onboarding from "app/images/analyze-onboarding.png";
import { useTranslation } from "react-i18next";

interface IProps {
  // The paywall's copy (from its GrowthBook flag, defaulting to today's). A
  // line break in the headline starts a new line.
  headline: string;
  tagline: string;
  features: string[];
}

const ShowcasePanel = ({ headline, tagline, features }: IProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.showcase}>
      <h2 className={styles.heading}>
        {headline.split("\n").map((line, index) => (
          <React.Fragment key={index}>
            {index > 0 && <br />}
            {line}
          </React.Fragment>
        ))}
      </h2>
      <div className={styles.body}>
        <img
          src={onboarding}
          alt=""
          aria-hidden="true"
          className={styles.preview_image}
        />
        <div className={styles.card}>
          <div className={styles.brand}>
            <img
              src={coachnow_logo}
              alt="CoachNow"
              className={styles.brand_logo}
            />
            <img
              src={analyze_badge}
              alt={t("Analyze")}
              className={styles.brand_badge}
            />
          </div>
          <p className={styles.tagline}>{tagline}</p>
          <div className={styles.divider} />
          <ul className={styles.features}>
            {features.map((feature, index) => (
              <li key={`${index}-${feature}`}>
                <img src={orange_check} alt="" aria-hidden="true" />
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ShowcasePanel;
